<template>
  <v-container grid-list-md fluid>
    <h2>クライアント管理</h2>

    <v-layout row align-center>
      <v-flex md3>
        <v-btn @click="addItem">
          <v-icon>add</v-icon>追加
        </v-btn>
      </v-flex>
      <v-flex md3>
        <input type="file" @change="selectedFile" />
      </v-flex>
      <v-flex md3>
        <v-btn :disabled='file==null' @click="importFile">インポート</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row align-center>
      <v-flex md4>
        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
      </v-flex>
    </v-layout>

    <v-spacer></v-spacer>
    <v-dialog v-model="dialog">
      <edit-item v-if="dialog" @closeDialog="closeDialog" @createItem="createItem" @updateItem="updateItem" v-model="selectedItem" :action="action" />
      <v-alert :value="errorMessage.length>0">{{errorMessage}}</v-alert>
    </v-dialog>
    <v-data-table :headers="headers" :items="items" :search="search" class="elevation-1" :pagination.sync="pagination" rows-per-page-text="表示行">
      <template slot="items" slot-scope="props">
        <tr>
          <td class="text-xs-left">{{ props.item.id }}</td>
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td>
            <v-btn icon @click="editItem(props.item)">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn icon @click="deleteItem(props.item)">
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
      <template slot="pageText" slot-scope="props">
        {{ props.itemsLength }} 件中 {{ props.pageStart }} - {{ props.pageStop }} 件表示
      </template>
    </v-data-table>

  </v-container>
</template>

<script>

import db from '@/components/firebaseInit'
import auth from '@/components/fireAuthInit'
import EditItem from "@/components/clients/editClient.vue"
import firebase from 'firebase'
import { mapMutations } from 'vuex'
import XLSX from 'xlsx'
export default {
  components: {
    EditItem
  },
  data() {
    return {
      items: [],
      dbRef: db.collection("clients"),
      action: "add",
      dialog: false,
      selectedItem: {},
      newItem: { id: "", name: "" },
      errorMessage: "",
      headers: [
        {
          text: 'ID',
          align: 'left',
          sortable: false,
          value: 'id'
        },
        {
          text: '顧客名',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: '操作', sortable: false },
      ],
      file: null,
      pagination: {
        rowsPerPage: 50
      },
      search: ""
    }

  },
  mounted() {
    this.changeLoadingState(true)

    this.reloadItems()
  },
  methods: {
    async reloadItems() {
      this.changeLoadingState(true)
      this.items = []
      const items = await this.dbRef.get()
      items.forEach((doc) => {
        this.items.push({ ...doc.data(), id: doc.id })
      })
      this.changeLoadingState(false)
    },
    closeDialog() {
      this.errorMessage = ""
      this.dialog = false
    },
    async createItem() {
      this.selectedItem.keyword = this.selectedItem.id + "_" + this.selectedItem.name
      try {
        await this.dbRef.doc(this.selectedItem.id).set(this.selectedItem)
        this.closeDialog()
        this.reloadItems()
      } catch (e) {
        //this.errorMessage = authErrorCodeToMessage(e.code)
        console.log(e)

      }
    },
    editItem(item) {
      this.selectedItem = JSON.parse(JSON.stringify(item))
      this.action = "update"
      this.dialog = true
    },
    addItem() {
      this.selectedItem = JSON.parse(JSON.stringify(this.newItem))
      this.action = 'add'
      this.dialog = true
    },

    async deleteItem(item) {
      try {
        await this.dbRef.doc(item.id).delete()
        this.reloadItems()
      } catch (e) {
        console.log(e)
      }

    },
    async updateItem() {
      this.selectedItem.keyword = this.selectedItem.id + "_" + this.selectedItem.name
      await this.dbRef.doc(this.selectedItem.id).set(this.selectedItem)
      this.closeDialog()
      this.reloadItems()
    },
    selectedFile(e) {
      e.preventDefault();
      this.file = e.target.files[0]
    },
    importFile() {
      this.changeLoadingState(true)
      const reader = new FileReader()
      reader.readAsArrayBuffer(this.file)
      reader.onload = (e) => {
        const data = new Uint8Array(reader.result)
        const workbook = XLSX.read(data, { type: "array" })
        const worksheet = workbook.Sheets[workbook.SheetNames[0]]
        const items = XLSX.utils.sheet_to_json(worksheet)
        this.createItems(items)
      }
    },
    async createItems(items) {
      const promises = []
      try {
        items.forEach(item => {
          item.keyword = item.id + "_" + item.name
          const p = this.dbRef.doc(item.id).set(item)
          promises.push(p)
        })

      } catch (e) {
        //this.errorMessage = authErrorCodeToMessage(e.code)
        console.log(e)
      }
      await Promise.all(promises)
      this.reloadItems()
    },
    ...mapMutations('app', ['changeLoadingState'])
  },
  created: function () {
  }

}
</script>
<style lang="scss" scoped>
</style>